angular.module('common_app').filter(
  'strReplace',
  () =>
    (input = '', from = '', to = '') =>
      input.replace(new RegExp(from, 'g'), to),
);
